module.exports = __webpack_public_path__ + "assets/img/event1.f39e050d.jpg";